import { Log } from '@devanjs/log';
import { computedAsync } from '@vueuse/core';
import { resolve } from './asyncIntegration';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { IntegrationsStore } from './types/integrationsStore';

export const useIntegration = <
  K extends keyof Integrations,
  Integrations extends Record<string, PossiblyAsyncIntegration>,
>(
  code: K,
  store: IntegrationsStore<Integrations>,
) => {
  const integration = store.integrations[code];

  if (integration === undefined) {
    Log.red('Integrations').info(`Integration ${code.toString()} not found`);
  }

  return computedAsync(() => resolve(integration, store), integration as any);
};
